import { IntegrationFieldBuilder } from './integration-field-builder'
import { CheckboxFieldConfig } from '../integration-form-types/integration-field-config'
import { IntegrationFormField } from '../integration-form-types/integration-form-field'
import { SupportedFormFields } from '../integration-form-types/supported-form-field-types'

interface CheckboxField extends IntegrationFormField {
  config: CheckboxFieldConfig
}

export class CheckboxFieldBuilder extends IntegrationFieldBuilder {
  field: SupportedFormFields = 'checkbox_field'

  config: CheckboxFieldConfig = {
    placement: 1,
    label: '',
    checked: false,
    metadataKey: '',
  }

  placement(placement: number): this {
    this.config.placement = placement
    return this
  }

  isHidden(hidden: boolean | undefined): this {
    this.config.isHidden = hidden
    return this
  }

  checked(checked: boolean): this {
    this.config.checked = checked
    return this
  }

  label(value: string): this {
    this.config.label = value
    return this
  }

  metadataKey(key: string): this {
    this.config.metadataKey = key
    return this
  }

  build(): CheckboxField {
    const CheckboxField: CheckboxField = {
      field: this.field,
      config: this.config,
    }

    if (!this.verifyBuiltField(CheckboxField)) {
      console.error('Error in the config sent to Checkbox Field Builder.')
    }

    return CheckboxField
  }

  verifyBuiltField(field: CheckboxField): boolean {
    if (field.field !== 'checkbox_field') {
      return false
    }

    if (field.config.metadataKey == '') {
      console.error(
        'The Checkbox Field builder cannont have an empty string as the value for the metadataKey. Use the metadataKey builder call to set this value.',
      )
      return false
    }

    if (field.config.label == '') {
      console.error(
        'The Checkbox Field builder cannont have an empty string as the value for the label. Use the label builder call to set this value.',
      )
      return false
    }

    return true
  }
}
